import { default as _91_46_46_46slug_93GKJStx54CbMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/[...slug].vue?macro=true";
import { default as index7PjQtfypToMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/auth/index.vue?macro=true";
import { default as index2XPAvvqA9bMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as datenschutzzjW3gk0VJoMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/datenschutz.vue?macro=true";
import { default as datenverarbeitungApPyEd9ISvMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/datenverarbeitung.vue?macro=true";
import { default as _91id_93GXVkwtrd4NMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93Yzfx1RpGU2Meta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/formProcess/success/[id].vue?macro=true";
import { default as impressumoW0E43310GMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/impressum.vue?macro=true";
import { default as indexQszePwrgQCMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/index.vue?macro=true";
import { default as _91slug_9392eh1zuEMjMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/news/[slug].vue?macro=true";
import { default as organisationsmpvMw6ayXRMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/organisations.vue?macro=true";
import { default as indexWMAiBYefLYMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/processes/index.vue?macro=true";
import { default as dungeonV1fmzYEpu0Meta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsDNic1TQM6sMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexxjGe3lFpLGMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/secret/index.vue?macro=true";
import { default as indexMKLjhOuesvMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDatay6OMMbPewxMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassIDy4Z4WkqyMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93D57DkP8Y9DMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexMGMz1DQO8UMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDatapL4Icen2k6Meta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramReportsvStJWQURTeMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRights2zdVGWGdxeMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_934b6mV7KNdJMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indextfQqUV5fkuMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivities7M3AzRAjdGMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataGv8eiOKhWlMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93e4jDn7zQD1Meta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexeAT6Nkqvh9Meta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesLQcFbDdzSpMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataUM0hwY5lJdMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93EEI1m4G2lSMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as index1zUj4JCLBiMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataF0yjIVn1L3Meta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93dpu69W6S3OMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexF99HnjGvf9Meta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statusActivitiestI9wPKbevmMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataePd35sUEBqMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsix0q99lIuGMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93toyvoYiWwuMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexIQiwE2hndtMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataDOuDogMMTEMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDataFKhpd2FYjFMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as yearInterviewslNNg6g5XHFMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/years/[id]/yearInterviews.vue?macro=true";
import { default as _91id_93l5i9tJCTBaMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexiQHKf8eyMUMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataAy8wGpbQdGMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93mmF2M4q6oMMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexXEiyNigFoXMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/index.vue?macro=true";
import { default as paymentRunActivitieslJhdvP69OSMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue?macro=true";
import { default as paymentRunBaseDataK0HDmXNGDlMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPayments7EvAUoXmIjMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93uOB8JUA9TgMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexEYIvLVcmOVMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentszCausNGA1wMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesX7YL02A8csMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataabmLdfTRnFMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_933NT0BV07xGMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/processes/[id].vue?macro=true";
import { default as indexqHf5rPlwcMMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalZQgki3iTIFMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93oIx8PEHEpsMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexWwdA6FLCdFMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProviderswEvEny8MZyMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesxtT9BZ7rAKMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsa6PbglHVxUMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDatadRobMBGYixMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesn8p2qifCaAMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationProtectionConcept3aRwUKsKUuMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationProtectionConcept.vue?macro=true";
import { default as organisationStemSheetW6rC065I9iMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationStemSheet.vue?macro=true";
import { default as organisationUsers5yiDAZrdzTMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93mmZIn0gaoqMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexRugaCIaGODMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisations1HMoBipxbKMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesXpCoGBzn5eMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDatacynjbwERgwMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFilters3FXTgQjdkyMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignaturerGkZ5ttovGMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93IOrJXEybkgMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/[id].vue?macro=true";
import { default as index1o5rGzlCwyMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersUZomVihcwrMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users.vue?macro=true";
import { default as settingsg0NMuYwADKMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings.vue?macro=true";
import { default as servicePf47EUxQ30Meta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/service.vue?macro=true";
import { default as index6fuBdmQ8EUMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/childOrganisations/index.vue?macro=true";
import { default as languageJGldsmwyeRMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDatartZgWrkpjKMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories11RSfvaLXHMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationProtectionConceptMMAZ7Xbl0HMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id]/organisationProtectionConcept.vue?macro=true";
import { default as organisationStemSheetnaqdOzzVANMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id]/organisationStemSheet.vue?macro=true";
import { default as organisationUsersUOroccX4kGMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93pBLWJBpyf3Meta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseData8jAcdHthyjMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureWwiI1kxFhRMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_937ptt8OeiQdMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings/users/[id].vue?macro=true";
import { default as settings4YjrpfGZr1Meta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/settings.vue?macro=true";
import { default as signature1iyJqu7WAZMeta } from "/home/forge/oase-aej.de/releases/82168262/client/pages/signature.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93GKJStx54CbMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: index7PjQtfypToMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: index2XPAvvqA9bMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/datenschutz.vue")
  },
  {
    name: "datenverarbeitung",
    path: "/datenverarbeitung",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/datenverarbeitung.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93GXVkwtrd4NMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93Yzfx1RpGU2Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/impressum.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexQszePwrgQCMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/index.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsmpvMw6ayXRMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexWMAiBYefLYMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/processes/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: servicePf47EUxQ30Meta?.name,
    path: "/service",
    meta: servicePf47EUxQ30Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataAy8wGpbQdGMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexMKLjhOuesvMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93D57DkP8Y9DMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexMGMz1DQO8UMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_934b6mV7KNdJMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indextfQqUV5fkuMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93e4jDn7zQD1Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexeAT6Nkqvh9Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93EEI1m4G2lSMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: index1zUj4JCLBiMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93dpu69W6S3OMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexF99HnjGvf9Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93toyvoYiWwuMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsix0q99lIuGMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexIQiwE2hndtMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93l5i9tJCTBaMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/years/[id]/yearData.vue")
  },
  {
    name: "service-basicData-years-id-yearInterviews",
    path: "yearInterviews",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/years/[id]/yearInterviews.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexiQHKf8eyMUMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93mmF2M4q6oMMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/index.vue")
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentszCausNGA1wMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93uOB8JUA9TgMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunActivities",
    path: "paymentRunActivities",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexEYIvLVcmOVMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_933NT0BV07xGMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexqHf5rPlwcMMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalZQgki3iTIFMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsg0NMuYwADKMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProviderswEvEny8MZyMeta?.name,
    path: "loginProviders",
    meta: loginProviderswEvEny8MZyMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93oIx8PEHEpsMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexWwdA6FLCdFMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisations1HMoBipxbKMeta?.name,
    path: "organisations",
    meta: organisations1HMoBipxbKMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93mmZIn0gaoqMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationProtectionConcept",
    path: "organisationProtectionConcept",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationProtectionConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationStemSheet",
    path: "organisationStemSheet",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationStemSheet.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexRugaCIaGODMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersUZomVihcwrMeta?.name,
    path: "users",
    meta: usersUZomVihcwrMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93IOrJXEybkgMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: index1o5rGzlCwyMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settings4YjrpfGZr1Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings.vue"),
    children: [
  {
    name: "settings-childOrganisations",
    path: "childOrganisations",
    meta: index6fuBdmQ8EUMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/childOrganisations/index.vue")
  },
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93pBLWJBpyf3Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationProtectionConcept",
    path: "organisationProtectionConcept",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id]/organisationProtectionConcept.vue")
  },
  {
    name: "settings-organisations-id-organisationStemSheet",
    path: "organisationStemSheet",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id]/organisationStemSheet.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_937ptt8OeiQdMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signature1iyJqu7WAZMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/82168262/client/pages/signature.vue")
  }
]